<template lang="pug">
  div.invoice-control
    e-toolbar(
      :items="items"
      :hideRemoveButton="true"
      :showTotal="true"
      :showViewPanel="false"
      :hideImportBtn="true"
      :hideAddButton="true"
    )

    e-table(
      :defaultColumnWidth="150"
      :items="items"
      :showCheckbox="false"
      ref="table"
      actionColumnWidth="200"
      actionColumnTitle="Связанные банковские пачки"
    )
      div(slot="links" slot-scope="{row}")

      div(slot="actionButtons" slot-scope="{row}")
        div(
          v-if="row.links && row.links.length"
        ).links
          div(
            v-for="link in row.links"
            :key="link.id"
          )
            router-link(
              :to="{name: 'bankPackets.uploadedPackets.operations', params: {id: link.bank_packet_id}}"
            ) {{link.id}}
            span  Информация о дубликатах недоступна

        div(style="text-align: center;")
          a(
            v-if="userCanCreate"
            href="#"
            @click.prevent="createLink(row)"
          ) {{$translate('Привязать')}}
          span(
            v-else
          )  -

    router-view(
      @success="onSuccess"
    )
</template>

<script>
  import {invoiceControl} from '../../api/api-endpoints.js'
  import tableMixin from "../../components/table/table-mixin.js"
  import permissionMixin from '../../mixins/permission-mixin.js'

  export default {
    mixins: [tableMixin, permissionMixin],
    methods: {
      onSuccess () {
        this.$refs.table && this.$refs.table.scrollTableToTop()
      },
      getEndpoint (route) {
        return invoiceControl.bankStatementItems(route.params.statementId, route)
      },
      createLink(row) {
        const {route, json} = this.getRoute()
        this.$router.push({
          name: route.name + '.bankStatementItemsLink.create',
          params: route.params,
          query: {
            prevRoute: json,
            setFields: JSON.stringify({
              statement_id: row.id
            })
          }
        })
      }
    }
  }
</script>
